import { defineComponent as _defineComponent } from 'vue'
import { PartnerTrade, tradeExecutionMethodLabels, formatHedgingInstrument, HedgingInstruments } from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { formatDate, FULL_DATE_AND_TIME_FORMAT } from 'ah-common-lib/src/helpers/time';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeReportDetails',
  props: {
    trade: null
  },
  setup(__props: any) {

const props = __props as {
  trade: PartnerTrade;
};



const executionMethod = computed(() => tradeExecutionMethodLabels[props.trade.executionMethod] || '-');

const isVanillaOptions = computed(() => {
  return props.trade.hedgingProduct === HedgingInstruments.VANILLA_OPTIONS;
});

return { __sfc: true,props, executionMethod, isVanillaOptions, formatHedgingInstrument, formatCurrencyValue, formatDate, FULL_DATE_AND_TIME_FORMAT }
}

})